import { getMortgageValueIds, getWealthLevelIds } from './dataHelper';

export const getDataAsSearchParams = (formData, data) => {
    const params = {};
    if (data?.adviceArea) {
        params.attribute_ids = data.adviceArea;
    }

    if (formData?.postcode) {
        params.location = formData.postcode;
    }

    if (data?.postcode) {
        params.location = data.postcode;
    }

    if (formData?.wealthLevel) {
        params.wealth_level_ids = getWealthLevelIds(formData.wealthLevel);
    }

    if (formData?.mortgageValue) {
        params.mortgage_level_ids = getMortgageValueIds(formData.mortgageValue);
    }

    return params;
};
